import { getToken } from '../api/client.js';

export async function shouldShowMaintenanceScreen(data) {
  if (!data?.maintenanceMode) return false;
  if (data?.isAdmin) return false;
  const token = getToken();
  if (!token) return true;
  try {
    const {
      apiRequestJson
    } = await import('../api/client.js');
    const me = await apiRequestJson('nitromule/v1/me', {
      method: 'GET'
    });
    if (me?.data?.is_admin === true || me?.data?.role === 'admin') return false;
  } catch (_) {}
  return true;
}
